// extracted by mini-css-extract-plugin
export var buttonContainer = "_88-1";
export var fontSizeSelect = "_88-3";
export var formatSelect = "_88-2";
export var formats = "_88-4";
export var hidden = "_88-5";
export var icon = "_88-6";
export var select = "_88-0";